export const colors = {
  primary: "#0052cc",
  primaryDark: "#0043a8",
  primaryFocusRing: "rgba(0, 82, 204, 0.12)",
  white: "#ffffff",
  textPrimary: "#0f172a",
  textSecondary: "#64748b",
  textMuted: "#94a3b8",
  textLabel: "#1e293b",
  border: "#e2e8f0",
  error: "#dc2626",
  errorBg: "#fef2f2",
  errorBorder: "#fecaca",
  errorText: "#b91c1c",
  disabledBg: "#cbd5e1",
  disabledText: "#94a3b8",
  brandGradientStart: "#030812",
  brandGradientMid: "#071225",
  brandGradientEnd: "#0c1a33",
  brandSubtitle: "#cbd5e1",
  brandTitle: "#ffffff",
  featureTitle: "#f8fafc",
  featureDesc: "#94a3b8",
  formPanelBg: "#f4f6f9",
  cardBg: "#ffffff",
  heading: "#0b1f3f",
  bodyBg: "#f1f5f9",
  featurePackagesBg: "rgba(0, 82, 204, 0.24)",
  featurePackagesColor: "#60a5fa",
  featureCouponsBg: "rgba(124, 58, 237, 0.26)",
  featureCouponsColor: "#c4b5fd",
  featureUploadsBg: "rgba(34, 197, 94, 0.24)",
  featureUploadsColor: "#4ade80",
  cardShadow: "rgba(15, 23, 42, 0.08)",
  infoBg: "#eff6ff",
  infoBorder: "#bfdbfe",
  infoText: "#1e40af",
  surfaceMuted: "#f8fafc",
  surfaceHover: "#fafbfc",
  dropZoneBorder: "#93c5fd",
  success: "#16a34a",
  tableCell: "#334155",
  tableRowBorder: "#f1f5f9",
  statusProcessedBg: "#dcfce7",
  statusProcessedText: "#15803d",
  statusPartialBg: "#ffedd5",
  statusPartialText: "#c2410c",
  statusUploadedBg: "#dbeafe",
  statusUploadedText: "#1d4ed8",
  statusPendingBg: "#f1f5f9",
  statusFailedBg: "#fee2e2",
  statusFailedText: "#b91c1c",
};

export const fontSizes = {
  xs: "0.8rem",
  sm: "0.86rem",
  md: "0.88rem",
  base: "0.94rem",
  lg: "0.98rem",
  xl: "1rem",
  "2xl": "1.4rem",
  "3xl": "1.65rem",
  "4xl": "1.75rem",
  "5xl": "2.75rem",
};

export const fontWeights = {
  semibold: 600,
  bold: 700,
};

export const radii = {
  sm: "8px",
  md: "10px",
  lg: "12px",
  xl: "14px",
};

export const shadows = {
  card: `0 10px 40px ${colors.cardShadow}`,
  panel: `0 1px 3px ${colors.cardShadow}, 0 4px 16px rgba(15, 23, 42, 0.04)`,
};

export const fontFamily = {
  primary: "Montserrat, sans-serif",
};

const toCssVarName = (key) =>
  key.replace(/([A-Z])/g, "-$1").toLowerCase();

export const getCssVariables = () => {
  const variables = {};

  Object.entries(colors).forEach(([key, value]) => {
    variables[`--color-${toCssVarName(key)}`] = value;
  });

  Object.entries(fontSizes).forEach(([key, value]) => {
    variables[`--font-size-${key}`] = value;
  });

  Object.entries(fontWeights).forEach(([key, value]) => {
    variables[`--font-weight-${key}`] = value;
  });

  Object.entries(radii).forEach(([key, value]) => {
    variables[`--radius-${key}`] = value;
  });

  variables["--shadow-card"] = shadows.card;
  variables["--shadow-panel"] = shadows.panel;
  variables["--font-family-primary"] = fontFamily.primary;

  return variables;
};
